import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentOutsideLayout } from './outside-component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    ComponentOutsideLayout],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ComponentOutsideLayout
  ]
})
export class AuthModule { }
